export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/11a14d9b63ec892bb84cea8c67204259.svg";